var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRvtSymbolNegBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Art",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.08 254.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.04,
    y: 9,
    width: 15.99,
    height: 236.75,
    transform: "translate(-52.86 127.06) rotate(-44.97)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.16,9.18v86.31c0,5.06-4.11,9.17-9.17,9.17h-35.35v-18.35h26.17V18.36H18.36v150.09H0V9.18C0,4.12,4.12,0,9.18,0h165.81c5.06,0,9.17,4.12,9.17,9.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.08,86.3v159.28c0,5.06-4.12,9.17-9.18,9.17H79.1c-5.06,0-9.18-4.11-9.18-9.17v-86.31c0-5.06,4.12-9.18,9.18-9.18h35.34v18.36h-26.17v67.95h147.46V86.3h18.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRvtSymbolNegBlack);
export default __webpack_public_path__ + "static/media/RVT-Symbol-Neg-Black.12758f8385f19d31eb03840e423bf779.svg";
export { ForwardRef as ReactComponent };